import React from 'react';

import { getPriceAndVolumeRatio } from "api/urls";


import GraphContainer from 'components/wrapper/GraphContainer';


const PriceAndVolumeChart = (props) => {

    const xkey = 'date'
    const tabs = [
        { title: "Price Chart", field: 'close' },
        { title: "Volume Chart", field: 'deliverable_volume', }
    ]

    const setUrl = (type, company__symbol) => {
        let url = getPriceAndVolumeRatio(type, company__symbol)
        return { url }
    }

    return (
        <div  {...props}>
            <GraphContainer
                setUrl={setUrl}
                tabs={tabs}
                xkey={xkey}
            />
        </div>
    )
};

export default (PriceAndVolumeChart);